import React from 'react';
import _ from 'lodash';

import {
  BaseWidget,
  InviteUserModal,
  PermissionWall
} from 'modules';
import {
  modalUtil,
  Table
} from 'iron-forge-react-modules';

import { Button } from '@mui/material';
import * as dataService from './dataService';
import * as types from './types';



const TableComponent = Table.genTableComponent<types.IColumnId>();



export const FC: React.FC = () => {
  const queryTuple = dataService.useQuery();

  const {
    modalType2IsOpen,
    setModalIsOpen
  } = modalUtil.useModalTrackers(['inviteUser']);



  function handleClickInviteUser() {
    setModalIsOpen('inviteUser', true);
  }

  function handleCloseInviteUserModal() {
    setModalIsOpen('inviteUser', false);
  }



  const rows = React.useMemo(
    () => _.map(queryTuple.data.invites, (invite): types.IRow => ({
      id: invite.id,
      columnId2Value: {
        email: {
          type: 'string',
          label: invite.email
        },
        sentTimestamp: {
          type: 'string',
          label: invite.sentTimestamp?.toFormat('yyyy-MM-dd @ hh:mm:ss a') ?? 'N/A'
        },
        isClaimed: {
          type: 'string',
          label: invite.isClaimed ? 'Yes' : 'No'
        }
      }

    })),
    [queryTuple.data.invites]
  );



  return (
    <>
      <BaseWidget.FC
        title="Invites"
        elAction={(
          <PermissionWall.FC requiresPermissions={['user_invite']}>
            <Button
              variant="contained"
              onClick={handleClickInviteUser}>
              Invite User
            </Button>
          </PermissionWall.FC>
        )}>

        <TableComponent
          rows={rows}
          columns={[
            {
              id: 'email',
              label: "Email"
            },
            {
              id: 'sentTimestamp',
              label: "Sent at"
            },
            {
              id: 'isClaimed',
              label: "Is claimed?"
            }
          ]} />

      </BaseWidget.FC>

      {modalType2IsOpen.inviteUser && (
        <InviteUserModal.FC
          onClose={handleCloseInviteUserModal} />
      )}
    </>
  );
};
